import { Radio, Typography } from '@mui/material';
import styled, { css } from 'styled-components';

export const ReportsContainer = styled.div`
  margin-top: 32px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export const ReportTile = styled.div(
  ({ theme: { shape } }) => css`
    width: 160px;
    height: 160px;
    border-radius: ${shape.borderRadius * 2}px;
    background-color: #eff0f5;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: #e9ebf0;
    }
  `,
);

export const ReportTitle = styled(Typography)`
  font-weight: 700;
  text-align: center;
`;

export const FieldContainer = styled.div`
  margin-bottom: 20px;
`;

export const RadioGroupLabel = styled(Typography)`
  font-weight: 700;
  margin-bottom: 10px;
`;

export const StyledRadio = styled(Radio)`
  &.Mui-checked {
    background-color: ${({ theme }) => theme.palette.primary.main};
    border-radius: 50%;

    & .MuiSvgIcon-root {
      color: white;
    }
  }

  & .MuiSvgIcon-root {
    border: none;
  }

  background-color: #f5f5f5;
  border-radius: 50%;
`;
